import {
  AutoComplete,
  Button,
  Drawer,
  Form,
  Input,
  Spin,
  Switch,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import {
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import Empty from "../common/Empty";
import { responseNotification } from "../../utils/notify";
import debounce from "lodash";
import AddRegion from "./AddRegion";

const RegionList = ({
  inHub = false,
  activeSearch = true,
  refetch,
}: {
  inHub?: boolean;
  activeSearch?: boolean;
  refetch?: boolean;
}) => {
  const [visible, setVisible] = useState(undefined);
  const [selectedRegion, setselectedRegion] = useState(undefined);
  const [selectedRegionForEdit, setSelectedRegionForEdit] = useState(undefined);

  const [key, setKey] = useState("");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [regionData, setRegionData] = useState({
    loading: false,
    data: null,
  });

  const [regionOptions, setRegionOptions] = useState({
    loading: false,
    list: null,
  });

  const [hubId, setHubId] = useState<any>();
  const [regionId, setRegionId] = useState<any>();

  const fetchRef = useRef(null);
  const route = useParams();
  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const reseAllFieldData = () => {
    setStatus("");
    setKey("");
    setType("");
    form.resetFields();
  };

  const handleChangeStatus = (value: string) => {
    setStatus(value);
  };

  const getRegion = useCallback(
    async (getHubId) => {
      setRegionData({ loading: true, data: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      if (inHub) {
        axios
          .get(
            `${encodedUri}/hub/region?` +
              (key ? `&key=${key}` : ``) +
              (regionId ? `&regionId=${regionId}` : ``) +
              (getHubId ? `&id=${getHubId}` : ``) +
              `&page=${page || 0}` +
              `&limit=${limit || 16}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          )
          .then((res) => {
            setRegionData({ loading: false, data: res.data });
          })
          .catch((err) => {
            setRegionData({ loading: false, data: [] });
            console.error("Region: Error", err);
          });
      } else {
        axios
          .get(
            `${encodedUri}/region?` +
              (key ? `&key=${key}` : ``) +
              (regionId ? `&regionId=${regionId}` : ``) +
              (hubId ? `&hubId=${hubId}` : ``) +
              `&page=${page || 0}` +
              `&limit=${limit || 16}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          )
          .then((res) => {
            setRegionData({ loading: false, data: res.data });
          })
          .catch((err) => {
            setRegionData({ loading: false, data: [] });
            console.error("Region: Error", err);
          });
      }
    },
    [limit, page, key, regionId, hubId]
  );

  useEffect(() => {
    getRegion((route as any).hubId);
  }, [getRegion, refetch]);

  useEffect(() => {
    if (inHub) getRegion((route as any).hubId);
  }, [getRegion, inHub]);

  const getRegionOptions = useCallback(async (key) => {
    setRegionOptions({ loading: true, list: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/region?` +
          (key ? `&key=${key}` : ``) +
          // (getHubId ? `&id=${getHubId}` : ``) +
          `&page=${page || 0}` +
          `&limit=${limit || 16}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setRegionOptions({
          loading: false,
          list: res.data?.regions?.map((region: any) => ({
            label: region.name,
            value: region.name,
          })),
        });
      })
      .catch((err) => {
        setRegionOptions({ loading: false, list: [] });
        console.error("Categories: Error", err);
      });
  }, []);

  //
  const onDelete = async (id, val) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/region`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getRegion((route as any).hubId);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  //

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "region") getRegionOptions(value);
      }
    };

    return debounce(loadOptions);
  }, [getRegionOptions]);

  useEffect(() => {
    if (visible) {
      setselectedRegion(undefined);
      setSelectedRegionForEdit(undefined);
    }
  }, [selectedRegion, selectedRegionForEdit]);

  useEffect(() => {
    setselectedRegion(undefined);
    setSelectedRegionForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setselectedRegion(null);
    setSelectedRegionForEdit(null);
    getRegion((route as any).hubId);
    getRegion("");
    form.resetFields();
  };

  return (
    <React.Fragment>
      {!inHub && (
        <TopHeading {...regionData?.data?.totalElements} refetch={getRegion} />
      )}

      {activeSearch && (
        <section className="search_area">
          <Form form={form} className="search_form">
            <Form.Item
              name="region"
              initialValue={key}
              style={{ minWidth: 400 }}
            >
              <AutoComplete
                onSearch={getRegionOptions}
                onSelect={(val) => setKey(val.toString())}
                options={regionOptions?.list}
                defaultActiveFirstOption={false}
                notFoundContent={
                  regionOptions?.loading ? <Spin size="small" /> : null
                }
              >
                <Input.Search
                  size="large"
                  placeholder="Search by Name"
                  onSearch={(val) => {
                    setKey(val);
                  }}
                  enterButton
                  loading={regionOptions.loading}
                  pattern={`[0-9]`}
                  maxLength={11}
                />
              </AutoComplete>
            </Form.Item>
          </Form>

          <div className="search_btn">
            <Button
              type="primary"
              danger
              size="large"
              onClick={reseAllFieldData}
            >
              Reset
            </Button>
          </div>
        </section>
      )}
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Name</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {regionData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {regionData?.data?.regions?.length ? (
                    regionData?.data?.regions?.map(
                      (region: any, index: any) => (
                        <React.Fragment key={index}>
                          <div className="single-product-wrapper">
                            <div className="single-product">
                              <span className="name">{region?.name}</span>
                            </div>
                            <div className="single-product">
                              <span className="name">
                                {region?.type?.split("_").join(" ")}
                              </span>
                            </div>
                            <div className="single-product">
                              <Switch
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                                defaultChecked={region?.isActive}
                                onChange={(val, e) => {
                                  e.preventDefault();
                                  onDelete(region?.id, val);
                                }}
                                className="mr-2"
                              />
                            </div>
                            <div className="single-product">
                              {!inHub && (
                                <button
                                  className="btn btn-sm btn-warning mx-1"
                                  onClick={() =>
                                    setSelectedRegionForEdit(region)
                                  }
                                >
                                  <EditOutlined />
                                </button>
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Region" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={selectedRegionForEdit ? "Edit Thana" : "Thana Details"}
            width={selectedRegionForEdit ? 500 : 800}
            onClose={() => {
              setselectedRegion(null);
              setSelectedRegionForEdit(null);
            }}
            visible={selectedRegion || selectedRegionForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            <AddRegion
              visibleData={selectedRegionForEdit}
              onCloseMethod={onClose}
            />
          </Drawer>

          <PaginationTwo
            {...regionData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default RegionList;
